import { api } from './client.js';

export const systemLogsApi = {
  getAll: (params = {}) => {
    const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== null && value !== '' && value !== 'all') {
        acc[key] = value;
      }
      return acc;
    }, {});

    const queryParams = new URLSearchParams(cleanParams).toString();
    const endpoint = `/admin/system-logs${queryParams ? `?${queryParams}` : ''}`;
    return api.get(endpoint);
  },

  getById: (id) => {
    if (!id) return Promise.reject(new Error('Log ID is required'));
    return api.get(`/admin/system-logs/${id}`);
  },

  getStats: () => {
    return api.get('/admin/system-logs/stats');
  },

  getServices: () => {
    return api.get('/admin/system-logs/services');
  },

  getSettings: () => api.get('/admin/system-logs/settings'),

  updateSettings: (payload) => api.put('/admin/system-logs/settings', payload),

  export: (params = {}) => {
    const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== null && value !== '' && value !== 'all') {
        acc[key] = value;
      }
      return acc;
    }, {});

    const queryParams = new URLSearchParams(cleanParams).toString();
    const endpoint = `/admin/system-logs/export${queryParams ? `?${queryParams}` : ''}`;
    return api.get(endpoint);
  }
};

export default systemLogsApi;
